import { Spinner } from '@/components/Spinner';

/**
 * The interim boot state — the probe is with the server and the tablet claims nothing yet
 * [03-us-kad-6i AC-11].
 *
 * ⛔ **NO FRAME DRAWS THIS STATE, and that is a ruling rather than a gap** [decision `0307`, Operator
 * 2026-09-17, amended by him 2026-09-18]. `06 · Connecting` is the section's only waiting frame and it is
 * drawn for *six digits are with the server* — on a power-cycle nobody connected anything, so its eyebrow,
 * heading and body are false here. ⛔ **Nothing was invented to replace them.**
 *
 * ⭐ **What the Operator ruled, in two passes:** *"Just use a blank screen while reloading and checking the
 * enrolment."* — then *"Ok, add a spinner(if we have one in the app use that)."* So: the app's background
 * colour carrying **ONE drawn element**, the app's existing {@link Spinner}. ⛔ No heading, ⛔ no eyebrow,
 * ⛔ no copy, ⛔ no logo, ⛔ no card or `EnrolmentShell` — that shell draws a card with a logo block, and a
 * card with a logo on it is not this state — ⛔ no back or exit control.
 *
 * ⛔ **The page paints `--surface` ITSELF.** `index.css` sets no `body` or `html` background, so a component
 * that rendered `null` would show the browser's white — not the colour every other screen in this flow
 * paints [`EnrolmentShell`; `KioskScreen`], and a break in the flow rather than a continuation of it.
 *
 * ⛔ **The wait is NOT announced from here, and this file is the wrong place for it.** {@link Spinner} is
 * `role="presentation"`: it tells a sighted staffer that something is happening and says nothing at all to a
 * screen reader. The live region lives in `App`, above the enrolment fork, because a region inside this
 * subtree is unmounted by the verdict before a `polite` announcement on a healthy network can be spoken
 * [`EnrolmentAnnouncement`; `0307` § *The registration order*].
 */
export function CheckingEnrolmentScreen() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--surface)] font-sans">
      <Spinner />
    </main>
  );
}
